import { ethers } from 'ethers';
import tokenAbi from './abi/holesky/BlazPayPointsToken.json';
import productAbi from './abi/holesky/BlazpayProducts.json';
import stakeAbi from './abi/holesky/StakeShardeum.json';
import gameAbi from './abi/holesky/v2Testnet.json';
import newStakeAbi from './abi/newStake.json';

import productGamesAbi from './abi/arbitrum/ProductGames.json';
import productNFTsAbi from './abi/arbitrum/ProductNFTs.json';
import productTokenAbi from './abi/arbitrum/ProductToken.json';
import productStakeAbi from './abi/polygon/productStakeAbi.json';
import gamesDeposit from './abi/arbitrum/GamesDeposit.json';

export const chains = [
  // HEKLA
  // {
  //   id: '167009',
  //   name: 'Taiko Hekla L2',
  //   nativeCurrency: { name: 'ETH', symbol: 'ETH', decimals: 18 },
  //   rpcUrls: ['https://rpc.hekla.taiko.xyz'],
  //   tokenImg: 'https://i.ibb.co/y5D8dJv/taiko.png',
  //   explorerUrl: 'https://explorer.hekla.taiko.xyz/',
  //   features: {
  //     gameValue: 0,
  //     mintValue: 0,
  //     stakeValue: 0,
  //     apiStaking: false,
  //     gasLimit: false,
  //     isMainnet: false,
  //   },
  //   contracts: {
  //     // Entrypass: new ethers.Contract(''),
  //     NFT: new ethers.Contract(
  //       '0xdaEeF7cAB7fa7523da6f7481c850cb27406aE49A',
  //       stakeAbi
  //     ),
  //     Stake_Old1: new ethers.Contract(
  //       '0xD60dBbdFe2095Fd286998BEAcc0B3ce0D4fFFee3',
  //       stakeAbi
  //     ),
  //     Stake_Old2: new ethers.Contract(
  //       '0xdaEeF7cAB7fa7523da6f7481c850cb27406aE49A',
  //       stakeAbi
  //     ),
  //     Stake: new ethers.Contract(
  //       '0x977a52a98539667FbF5810A889B5780fa1704E2A',
  //       productStakeAbi
  //     ),
  //     Token1: new ethers.Contract(
  //       '0xB825e3D37691A59C4BDfD9C8549a79bc8d3A3B8b',
  //       tokenAbi
  //     ),
  //     Token2: new ethers.Contract(
  //       '0x979eBadf1a013d1b6BDAfDE7280B6398b7010C65',
  //       tokenAbi
  //     ),
  //     Token3: new ethers.Contract(
  //       '0xa75A5bEE03CC551999C193159f68b68768e16d7D',
  //       productTokenAbi
  //     ),
  //     Game: new ethers.Contract(
  //       // "0x0385B8f207D9e258373210deF12F3189f40897e7",
  //       '0x0768BDD56A00Fe7E18A91033d4b84Ddbb74d0201',
  //       productGamesAbi
  //     ),
  //     Product: new ethers.Contract(
  //       '0x20e66A615498176996e654fDA8391cd0D4a86e3b',
  //       productAbi
  //     ),
  //     Product1: new ethers.Contract(
  //       '0x67d91eC3d43FC21CbB3c6fFcc490677D077E8DfC',
  //       productAbi
  //     ),
  //     Deposit: new ethers.Contract(
  //       '0x7D167f7858454672021f0C2869a4AB54D219a997',
  //       gamesDeposit
  //     ),
  //   },
  // },

  // // HOLESKY
  // {
  //   id: '17000',
  //   name: 'Holesky',
  //   nativeCurrency: { name: 'ETH', symbol: 'ETH', decimals: 18 },
  //   rpcUrls: ['https://ethereum-holesky-rpc.publicnode.com'],
  //   explorerUrl: 'https://holesky.etherscan.io/',
  //   tokenImg: 'https://i.ibb.co/tHbx9Jw/arbitrum.png',
  //   features: {
  //     gameValue: 0,
  //     mintValue: 0,
  //     stakeValue: 0,
  //     unStakeValue: 0,
  //     apiStaking: false,
  //     gasLimit: false,
  //     onChainQuery: true,
  //     isMainnet: false,
  //   },
  //   contracts: {
  //     // Entrypass: new ethers.Contract(''),
  //     NFT: new ethers.Contract(
  //       '0x074D1a5ba06218D4a10020c801436231522EC669',
  //       stakeAbi
  //     ),
  //     Stake_Old1: new ethers.Contract(
  //       '0xd3592602FC5A8f4632f4b130618E09F7ed8e0705',
  //       stakeAbi
  //     ),
  //     Stake_Old2: new ethers.Contract(
  //       '0x074D1a5ba06218D4a10020c801436231522EC669',
  //       stakeAbi
  //     ),
  //     Stake: new ethers.Contract(
  //       '0x0EB9e382488e19d901856F130010D46074b5C064',
  //       productStakeAbi
  //     ),
  //     Token1: new ethers.Contract(
  //       '0x23Bd58929Efbe6469C188459D288437737191328',
  //       tokenAbi
  //     ),
  //     Token2: new ethers.Contract(
  //       '0xe914D607A64c5ac3b2c9db3e1b5D809ec4C2E4BF',
  //       tokenAbi
  //     ),
  //     Token3: new ethers.Contract(
  //       '0x6A7bAb58c360cf465Ad3191f4B5F2896917B4d11',
  //       productTokenAbi
  //     ),
  //     Game: new ethers.Contract(
  //       // "0x79E88A7a861395E33325796E58dEe1642f486d57",
  //       '0x38f4d439a65b587d780b4fd437EF89c6D9D83f6f',
  //       productGamesAbi
  //     ),
  //     Product: new ethers.Contract(
  //       // '0xb80DF4949437C4E01746b40D65Ce2ab0d73BB130',
  //       '0x0096Da996A60b730286d19963539aeE61Bc024B0',
  //       productAbi
  //     ),
  //     Deposit: new ethers.Contract(
  //       '0xb21248396B20E65d907843966f8795577f7f27CA',
  //       gamesDeposit
  //     ),
  //     //Store: new ethers.Contract(''),
  //   },
  // },

  // // ARBITRUM_SEPOLIA
  // {
  //   id: '421614',
  //   name: 'Arbitrum Sepolia',
  //   nativeCurrency: { name: 'ETH', symbol: 'ETH', decimals: 18 },
  //   rpcUrls: [
  //     'https://sepolia-rollup.arbitrum.io/rpc',
  //     'https://endpoints.omniatech.io/v1/arbitrum/sepolia/public',
  //   ],
  //   explorerUrl: 'https://sepolia.arbiscan.io/',
  //   tokenImg: 'https://i.ibb.co/tHbx9Jw/arbitrum.png',
  //   features: {
  //     gameValue: 0,
  //     mintValue: 0.00003,
  //     stakeValue: 0.00003,
  //     unStakeValue: 0.00003,
  //     apiStaking: false,
  //     gasLimit: false,
  //     isMainnet: false,
  //   },
  //   contracts: {
  //     // Entrypass: new ethers.Contract(''),
  //     NFT: new ethers.Contract(
  //       '0x074D1a5ba06218D4a10020c801436231522EC669',
  //       stakeAbi
  //     ),
  //     Stake: new ethers.Contract(
  //       '0xF3Acc2dcE7DEBa313DB04f5e5032D2cA377886a0',
  //       newStakeAbi
  //     ),
  //     Token3: new ethers.Contract(
  //       '0xa75A5bEE03CC551999C193159f68b68768e16d7D',
  //       productTokenAbi
  //     ),
  //     Game: new ethers.Contract(
  //       // '0x286f2C0bC322dF070CB0708a1745C1FECe1eB0f4',
  //       '0x67d91eC3d43FC21CbB3c6fFcc490677D077E8DfC',
  //       productGamesAbi
  //     ),
  //     Product: new ethers.Contract(
  //       '0x4dE7CD522f1715b2a48F3ad6612924841d450A0F',
  //       productNFTsAbi
  //     ),
  //     Deposit: new ethers.Contract(
  //       '0x5353700e3e702EB420CE039f4A0Cfcb0E1DA39B8',
  //       gamesDeposit
  //     ),
  //     //Store: new ethers.Contract(''),
  //   },
  // },

  // MONAD
  {
    id: '10143',
    name: 'Monad Testnet',
    nativeCurrency: { name: 'MON', symbol: 'MON', decimals: 18 },
    rpcUrls: [
      'https://testnet-rpc2.monad.xyz/52227f026fa8fac9e2014c58fbf5643369b3bfc6',
    ],
    explorerUrl: 'https://testnet.monadexplorer.com/',
    tokenImg: 'https://docs.monad.xyz/img/monad_logo.png',
    features: {
      gameValue: 0,
      mintValue: 0.00003,
      stakeValue: 0.00003,
      unStakeValue: 0.00003,
      apiStaking: false,
      gasLimit: false,
      isMainnet: false,
    },
    contracts: {
      NFT: new ethers.Contract(
        '0x074D1a5ba06218D4a10020c801436231522EC669',
        stakeAbi
      ),
      Stake: new ethers.Contract(
        '0xf38c90BbECeE227a7Ae153B1fA4c7216292C8b61',
        newStakeAbi
      ),
      Token3: new ethers.Contract(
        '0x38A3321A419B8688f539a600e3C7898a0528737f',
        productTokenAbi
      ),
      Game: new ethers.Contract(
        // '0x286f2C0bC322dF070CB0708a1745C1FECe1eB0f4',
        '0xaaDeCC979AC53FCa7Ee6b8f2A94A85F8F7f23729',
        productGamesAbi
      ),
      Product: new ethers.Contract(
        '0x07eeceF54B0A8F22B3f388997fD3a2C7e056dC7b',
        productNFTsAbi
      ),
      Deposit: new ethers.Contract(
        '0x55fc61c20b506fC79e64c03Fa015257da384cd83',
        gamesDeposit
      ),
      //Store: new ethers.Contract(''),
    },
  },

  // {
  //   id: '30732',
  //   name: 'Movement EVM Testnet',
  //   nativeCurrency: { name: 'MOVE', symbol: 'MOVE', decimals: 18 },
  //   rpcUrls: ['https://mevm.devnet.imola.movementlabs.xyz'],
  //   explorerUrl: 'https://explorer.movementlabs.xyz',
  //   tokenImg: 'https://i.ibb.co/ZXGvbMx/movement-Logo.jpg',
  //   features: {
  //     spinValue: 0,
  //     mintValue: 0,
  //     stakeValue: 0,
  //     unStakeValue: 0,
  //     apiStaking: false,
  //     gasLimit: false,
  //   },
  //   contracts: {
  //     // Entrypass: new ethers.Contract(''),
  //     NFT: new ethers.Contract(
  //       '0x27ddF355f35a772602e71E6C72f0a78132de627E',
  //       stakeAbi
  //     ),
  //     STAKE_OLD: new ethers.Contract(
  //       '0x27ddF355f35a772602e71E6C72f0a78132de627E',
  //       stakeAbi
  //     ),
  //     Stake: new ethers.Contract(
  //       '0x27ddF355f35a772602e71E6C72f0a78132de627E',
  //       stakeAbi
  //     ),
  //     Token1: new ethers.Contract(
  //       '0x31B1a5CE8A84f06b0b5C04eE01a04732aE804b0A',
  //       tokenAbi
  //     ),
  //     Token2: new ethers.Contract(
  //       '0x31B1a5CE8A84f06b0b5C04eE01a04732aE804b0A',
  //       tokenAbi
  //     ),
  //     Game: new ethers.Contract(
  //       '0xb7C401D897C778D33d92Be878Af013A24CA9D8Ed',
  //       gameAbi
  //     ),
  //     Product: new ethers.Contract(
  //       '0x44cb090877c2811ef75dBb50cb779a11ce6cFD31',
  //       productAbi
  //     ),
  //     //Store: new ethers.Contract(''),
  //   },
  // },

  // // POLYGON
  // {
  //   id: '137',
  //   name: 'Polygon Mainnet',
  //   rpcUrls: ['https://polygon-rpc.com/'],
  //   chainHex: '0x89',
  //   currency: 'MATIC',
  //   explorerUrl: 'https://polygonscan.com/',
  //   tokenImg: 'https://i.ibb.co/MDKTCF6/polygon.png',
  //   nativeCurrency: {
  //     name: 'MATIC',
  //     symbol: 'MATIC',
  //     decimals: 18,
  //   },
  //   features: {
  //     gameValue: 0.03,
  //     mintValue: 0.5,
  //     stakeValue: 0.5,
  //     apiStaking: false,
  //     gasLimit: false,
  //     isMainnet: true,
  //   },
  //   contracts: {
  //     NFT: new ethers.Contract(
  //       '0xc45F3DEbBecB8156fC8ac564343EA0eDF55B9E81',
  //       stakeAbi
  //     ),
  //     STAKE1: new ethers.Contract(
  //       '0x74638B17aF67e7A5EEaC0529EFa30b77572594Ae',
  //       stakeAbi
  //     ),
  //     STAKE2: new ethers.Contract(
  //       '0xc45F3DEbBecB8156fC8ac564343EA0eDF55B9E81',
  //       stakeAbi
  //     ),
  //     // Stake: new ethers.Contract(
  //     //   "0xc45F3DEbBecB8156fC8ac564343EA0eDF55B9E81",
  //     //   stakeAbi
  //     // ),
  //     Stake: new ethers.Contract(
  //       '0x2FBB643a241c87CeCf0a20c4f20650fCbD5941F1',
  //       productStakeAbi
  //     ),
  //     Token1: new ethers.Contract(
  //       '0x9a03A57265081ACB87a9EE66CC1D5C4F793C99D2',
  //       tokenAbi
  //     ),
  //     Token2: new ethers.Contract(
  //       '0x79E88A7a861395E33325796E58dEe1642f486d57',
  //       tokenAbi
  //     ),
  //     Token3: new ethers.Contract(
  //       '0xbe080A24C8DC66327e8473878edCae3EC10e130f',
  //       productTokenAbi
  //     ),
  //     // Game: new ethers.Contract(
  //     //   "0xbB3Fc1243Cb6852Ffca289D629C48A031050d3b7",
  //     //   gameAbi
  //     // ),
  //     Game: new ethers.Contract(
  //       // '0x1dE0602bb1D170a60b021f967B561Eb49FDddAc6',
  //       '0x45e1F4e850822c0Bc8c244e5cDd49c5De14Bb3E0',
  //       productGamesAbi
  //     ),
  //     Product: new ethers.Contract(
  //       '0x074D1a5ba06218D4a10020c801436231522EC669',
  //       productAbi
  //     ),
  //     Deposit: new ethers.Contract(
  //       '0xbF69a8c99e1e950332e5396d2289F6D5310A10B8',
  //       gamesDeposit
  //     ),
  //   },
  // },

  // // BSC
  // {
  //   id: '56',
  //   name: 'BNB Smart Chain Mainnet',
  //   nativeCurrency: {
  //     name: 'BNB',
  //     symbol: 'BNB',
  //     decimals: 18,
  //   },
  //   rpcUrls: ['https://bsc-dataseed1.binance.org/'],
  //   explorerUrl: ['https://bscscan.com/'],
  //   tokenImg: 'https://i.ibb.co/VMVS2Hc/binance.png',
  //   features: {
  //     gameValue: 0.000018,
  //     mintValue: 0.002,
  //     stakeValue: 0.002,
  //     apiStaking: false,
  //     gasLimit: false,
  //     isMainnet: true,
  //   },
  //   contracts: {
  //     // BlazpayProducts: "0x49811d32824B746Ce4855de6172871fB47dBABb6",
  //     // GamesV2: "0xCE115148c65e8488288A5b44e2Fc3b7d37777e48",
  //     NFT: new ethers.Contract(
  //       '0x0E1230ffBF651651144231E39EBBe26C238B5d16',
  //       stakeAbi
  //     ),
  //     STAKE_OLD: new ethers.Contract(
  //       '0x10CFd016888788077b071A334a47B171AbcF6252',
  //       stakeAbi
  //     ),
  //     Stake: new ethers.Contract(
  //       '0x0274f6f77C7EBCB1EbA702aE11a7a04BD8fA242A',
  //       productStakeAbi
  //     ),
  //     Token1: new ethers.Contract(
  //       '0xA5d3f2a7dD90669843009617C15656D14327EB8d',
  //       tokenAbi
  //     ),
  //     Token2: new ethers.Contract(
  //       '0x075a66C62a96E1f81fe73D9f362599F0bE74bdcD',
  //       tokenAbi
  //     ),
  //     Token3: new ethers.Contract(
  //       '0x63424C5fc96DEDF00630d8ECF1c5982121Ec4e91',
  //       productTokenAbi
  //     ),
  //     Game: new ethers.Contract(
  //       '0xCE115148c65e8488288A5b44e2Fc3b7d37777e48',
  //       productGamesAbi
  //     ),
  //     Product: new ethers.Contract(
  //       '0x1ebbA67f4c78cFa8b58381f3D2474DaB3b133D77',
  //       productAbi
  //     ),
  //     Deposit: new ethers.Contract(
  //       '0x3802276DD519ae9dAae011829bF9e8b95cd5D0fE',
  //       gamesDeposit
  //     ),
  //   },
  // },

  // // MANTA
  // {
  //   id: '169',
  //   name: 'Manta Pacific Mainnet',
  //   nativeCurrency: { name: 'ETH', symbol: 'ETH', decimals: 18 },
  //   rpcUrls: ['https://pacific-rpc.manta.network/http'],
  //   explorerUrl: 'https://pacific-explorer.manta.network/',
  //   tokenImg: 'https://i.ibb.co/CPzhyTf/manta.png',
  //   features: {
  //     gameValue: 0.0000036,
  //     mintValue: 0.00007,
  //     stakeValue: 0,
  //     apiStaking: false,
  //     gasLimit: false,
  //     isMainnet: true,
  //   },
  //   contracts: {
  //     NFT: new ethers.Contract(
  //       '0xdaEeF7cAB7fa7523da6f7481c850cb27406aE49A',
  //       stakeAbi
  //     ),
  //     STAKE_OLD: new ethers.Contract(
  //       '0xb951A0a8afa9Fa5B729Ad3ade861a610bCb62Df6',
  //       stakeAbi
  //     ),
  //     Stake: new ethers.Contract(
  //       '0xBB7c405bAB67C0191cacCe92a93440fB5A871e2c',
  //       productStakeAbi
  //     ),
  //     Token1: new ethers.Contract(
  //       '0x3FD63640BbC970945C909338eE38371a4d8c13D6',
  //       tokenAbi
  //     ),
  //     Token2: new ethers.Contract(
  //       '0x979eBadf1a013d1b6BDAfDE7280B6398b7010C65',
  //       tokenAbi
  //     ),
  //     Token3: new ethers.Contract(
  //       '0x3C2Fd7C031EA322d99D063Df50f6367892244668',
  //       productTokenAbi
  //     ),
  //     Game: new ethers.Contract(
  //       '0x183FF5839dA2F74c3e861171Dba4440DBeE7542f',
  //       productGamesAbi
  //     ),
  //     Product: new ethers.Contract(
  //       '0xEEb788E8A677E8A9Ffc25040eb3810669110E55C',
  //       productAbi
  //     ),
  //     Deposit: new ethers.Contract(
  //       '0x7F4af39C4f3AaF044854cEd0858412e3e8E65874',
  //       gamesDeposit
  //     ),
  //   },
  // },

  // // LINEA
  // {
  //   id: '59144',
  //   name: 'Linea',
  //   nativeCurrency: {
  //     name: 'ETH',
  //     symbol: 'ETH',
  //     decimals: 18,
  //   },
  //   rpcUrls: ['https://linea.drpc.org'],
  //   blockExplorerUrls: ['https://lineascan.build/'],
  //   tokenImg: 'https://i.ibb.co/G7yghkS/linea-Logo.png',
  //   features: {
  //     gameValue: 0.0000036,
  //     mintValue: 0.00041,
  //     stakeValue: 0.00041,
  //     unStakeValue: 0,
  //     apiStaking: false,
  //     apiMinting: false,
  //     isMainnet: true,
  //   },
  //   contracts: {
  //     NFT: new ethers.Contract(
  //       '0x4694598904EC8909FA0f6A2992b2BaB4e43397E5',
  //       productNFTsAbi
  //     ),
  //     Stake: new ethers.Contract(
  //       '0x977a52a98539667FbF5810A889B5780fa1704E2A',
  //       productStakeAbi
  //     ),
  //     Token3: new ethers.Contract(
  //       '0xa75A5bEE03CC551999C193159f68b68768e16d7D',
  //       productTokenAbi
  //     ),
  //     Game: new ethers.Contract(
  //       '0x0768BDD56A00Fe7E18A91033d4b84Ddbb74d0201',
  //       productGamesAbi
  //     ),
  //     Product: new ethers.Contract(
  //       '0x67d91eC3d43FC21CbB3c6fFcc490677D077E8DfC',
  //       productAbi
  //     ),
  //     Deposit: new ethers.Contract(
  //       '0x7e3B78015f26405d5f2460c9A35F77d64CFA5A32',
  //       gamesDeposit
  //     ),
  //   },
  // },

  // // ARBITRUM
  // {
  //   id: '42161',
  //   name: 'Arbitrum One',
  //   nativeCurrency: { name: 'ETH', symbol: 'ETH', decimals: 18 },
  //   rpcUrls: [
  //     'https://endpoints.omniatech.io/v1/arbitrum/one/public',
  //     'https://arbitrum.llamarpc.com',
  //   ],
  //   explorerUrl: 'https://arbiscan.io/',
  //   tokenImg: 'https://i.ibb.co/tHbx9Jw/arbitrum.png',
  //   features: {
  //     gameValue: 0.00003,
  //     mintValue: 0.00003,
  //     stakeValue: 0.00003,
  //     unStakeValue: 0.00003,
  //     apiStaking: false,
  //     gasLimit: false,
  //     isMainnet: true,
  //   },
  //   contracts: {
  //     // Entrypass: new ethers.Contract(''),
  //     NFT: new ethers.Contract(
  //       '0x074D1a5ba06218D4a10020c801436231522EC669',
  //       stakeAbi
  //     ),
  //     Stake: new ethers.Contract(
  //       '0x10cA0B3b575F23CDBE66E0502585A4F7E2D8AaB6',
  //       productStakeAbi
  //     ),
  //     Token3: new ethers.Contract(
  //       '0xA3E882aC208d729ad63A0064af33b06B1E7EDF02',
  //       productTokenAbi
  //     ),
  //     Game: new ethers.Contract(
  //       '0x015289DB92E1A5A31a6A21c88F4127846be38C37',
  //       productGamesAbi
  //     ),
  //     Product: new ethers.Contract(
  //       '0x8001a63FAbc3D58800633fa584F267B9D6b5dEe5',
  //       productNFTsAbi
  //     ),
  //     Deposit: new ethers.Contract(
  //       '0x80178a54B7Ce9B9Fabb8fb6b2f2F4E76842257e5',
  //       gamesDeposit
  //     ),
  //     //Store: new ethers.Contract(''),
  //   },
  // },

  // // BITLAYER
  // // {
  // //   id: '200901',
  // //   name: 'Bitlayer Mainnet',
  // //   nativeCurrency: { name: 'BTC', symbol: 'BTC', decimals: 18 },
  // //   rpcUrls: ['https://rpc.bitlayer.org/'],
  // //   explorerUrl: 'https://www.btrscan.com/',
  // //   tokenImg: 'https://storage.googleapis.com/squidlor/photos/BitlayerLogo.png',
  // //   features: {
  // //     gameValue: 0.00003,
  // //     mintValue: 0.00003,
  // //     stakeValue: 0.00003,
  // //     unStakeValue: 0.00003,
  // //     apiStaking: false,
  // //     gasLimit: false,
  // //   },
  // //   contracts: {
  // //     // Entrypass: new ethers.Contract(''),
  // //     NFT: new ethers.Contract(
  // //       '0x60d94ae2a429be78a1099733356Ab88009B049EF',
  // //       stakeAbi
  // //     ),
  // //     Stake: new ethers.Contract(
  // //       '0x10cA0B3b575F23CDBE66E0502585A4F7E2D8AaB6',
  // //       productStakeAbi
  // //     ),
  // //     Token3: new ethers.Contract(
  // //       '0xA3E882aC208d729ad63A0064af33b06B1E7EDF02',
  // //       productTokenAbi
  // //     ),
  // //     Game: new ethers.Contract(
  // //       '0x015289DB92E1A5A31a6A21c88F4127846be38C37',
  // //       productGamesAbi
  // //     ),
  // //     Product: new ethers.Contract(
  // //       '0x8001a63FAbc3D58800633fa584F267B9D6b5dEe5',
  // //       productNFTsAbi
  // //     ),
  // //     //Store: new ethers.Contract(''),
  // //   },
  // // },
  // // {
  // //   id: "997",
  // //   name: "5ireChain Thunder",
  // //   nativeCurrency: {
  // //     name: "5ire",
  // //     symbol: "5ire",
  // //     decimals: 18,
  // //   },
  // //   rpcUrls: ["https://rpc.ga.5ire.network/"],
  // //   explorerUrl: ["https://explorer.ga.5ire.network/"],
  // //   tokenImg: "https://i.ibb.co/VMVS2Hc/binance.png",
  // //   features: {
  // //     spinValue: 0,
  // //     mintValue: 0,
  // //     stakeValue: 0,
  // //     apiStaking: false,
  // //     gasLimit: false,
  // //   },
  // //   contracts: {
  // //     NFT: new ethers.Contract(
  // //       "0xdaEeF7cAB7fa7523da6f7481c850cb27406aE49A",
  // //       stakeAbi
  // //     ),
  // //     Stake: new ethers.Contract(
  // //       "0xdaEeF7cAB7fa7523da6f7481c850cb27406aE49A",
  // //       stakeAbi
  // //     ),
  // //     Token2: new ethers.Contract(
  // //       "0x979eBadf1a013d1b6BDAfDE7280B6398b7010C65",
  // //       tokenAbi
  // //     ),
  // //     Game: new ethers.Contract(
  // //       "0x0385B8f207D9e258373210deF12F3189f40897e7",
  // //       gameAbi
  // //     ),
  // //     Product: new ethers.Contract(
  // //       "0xEEb788E8A677E8A9Ffc25040eb3810669110E55C",
  // //       productAbi
  // //     ),
  // //   },
  // // },
  // // {
  // //   id: "42766",
  // //   name: "ZKFair Mainnet",
  // //   nativeCurrency: { name: "USDC", symbol: "USDC", decimals: 18 },
  // //   rpcUrls: ["https://rpc.zkfair.io"],
  // //   explorerUrl: "https://scan.zkfair.io/",
  // //   tokenImg: "https://i.ibb.co/y5D8dJv/taiko.png",
  // //   features: {
  // //     spinValue: 0.1,
  // //     mintValue: 1.5,
  // //     stakeValue: 1.5,
  // //     unStakeValue: 1.5,
  // //     apiStaking: false,
  // //   },
  // //   contracts: {
  // //     // Entrypass: new ethers.Contract(''),
  // //     NFT: new ethers.Contract(
  // //       "0x8A2E7143f1b153f454836c2fef5d53Fe6d8bB02B",
  // //       zkfairStakeAbi
  // //     ),
  // //     Stake: new ethers.Contract(
  // //       "0x8A2E7143f1b153f454836c2fef5d53Fe6d8bB02B",
  // //       zkfairStakeAbi
  // //     ),
  // //     Token: new ethers.Contract(
  // //       "0x8bD6f3bD448FcaD043c7b08FafEb3AB04126d9d4",
  // //       tokenAbi
  // //     ),
  // //     Game: new ethers.Contract(
  // //       "0xfcc11fCfbAeD8135C13AA2f7129712787b0618d6",
  // //       mantaGameAbi
  // //     ),
  // //     Product: new ethers.Contract(
  // //       "0x85523d5EdA897884432Eec14A71B153FbA6832D1",
  // //       katlaProductAbi
  // //     ),
  // //     //Store: new ethers.Contract(''),
  // //   },
  // // },
  // // {
  // //   id: '8082',
  // //   name: '	Shardeum Sphinx 1.X',
  // //   nativeCurrency: {
  // //     name: 'SHM',
  // //     symbol: 'SHM',
  // //     decimals: 18,
  // //   },
  // //   rpcUrls: ['https://sphinx.shardeum.org/'],
  // //   explorerUrl: ['https://explorer-sphinx.shardeum.org/'],
  // //   tokenImg: 'https://i.ibb.co/y5D8dJv/taiko.png',
  // //   features: {
  // //     spinValue: 0,
  // //     mintValue: 0,
  // //     stakeValue: 0,
  // //     apiStaking: false,
  // //     gasLimit:true,
  // //   },
  // //   contracts: {
  // //     // Entrypass: new ethers.Contract(''),
  // //     NFT: new ethers.Contract(
  // //       '0x97E3aB56ec2C13ACA2993076523F5b3D10D4A138',
  // //       zkfairStakeAbi
  // //     ),
  // //     Stake: new ethers.Contract(
  // //       '0x97E3aB56ec2C13ACA2993076523F5b3D10D4A138',
  // //       zkfairStakeAbi
  // //     ),
  // //     Token: new ethers.Contract(
  // //       '0x427539B9f81cd890b554e4f3F36eBa6D6d96e61a',
  // //       tokenAbi
  // //     ),
  // //     Game: new ethers.Contract(
  // //       '0x60d078234bCDd1c86C5020D4a64A2213568765a4',
  // //       mantaGameAbi
  // //     ),
  // //     Product: new ethers.Contract(
  // //       '0x56345f409b17CE3943F521f9Ef9f0150435c43b4',
  // //       katlaProductAbi
  // //     ),
  // //   },
  // // },
  // // {
  // //   id: "167008",
  // //   name: "Katla L2",
  // //   nativeCurrency: { name: "ETH", symbol: "ETH", decimals: 18 },
  // //   rpcUrls: ["https://rpc.katla.taiko.xyz"],
  // //   tokenImg: "https://i.ibb.co/y5D8dJv/taiko.png",
  // //   explorerUrl: "https://explorer.katla.taiko.xyz/",
  // //   id: "167008",
  // //   name: "Taiko Katla L2",
  // //   nativeCurrency: { name: "ETH", symbol: "ETH", decimals: 18 },
  // //   rpcUrls: ["https://rpc.katla.taiko.xyz"],
  // //   tokenImg: "https://i.ibb.co/y5D8dJv/taiko.png",
  // //   explorerUrl: "https://explorer.katla.taiko.xyz/",
  // //   features: {
  // //     spinValue: 0,
  // //     mintValue: 0,
  // //     stakeValue: 0,
  // //     apiStaking: true,
  // //     gasLimit: false,
  // //   },
  // //   contracts: {
  // //     // Entrypass: new ethers.Contract(''),
  // //     NFT: new ethers.Contract(
  // //       "0xedd0dDaEdbc3FBf67aC4ff2ee14Ace669821eac1",
  // //       katlaNFTAbi
  // //     ),
  // //     Stake: new ethers.Contract(
  // //       "0x1670080000000000000000000000000000000003",
  // //       []
  // //     ),
  // //     Token: new ethers.Contract(
  // //       "0x14027051bB9fEDbb8D8559416b056C2CBf3aA238",
  // //       tokenAbi
  // //     ),
  // //     Game: new ethers.Contract(
  // //       "0x1A0ECe8a973Be50bd44842960D842dc35e3E83A4",
  // //       katlaGameAbi
  // //     ),
  // //     Product: new ethers.Contract(
  // //       "0xa3B919018c23f3F19A9CAb00C243245598666F87",
  // //       katlaProductAbi
  // //     ),
  // //   },
  // // },
  // // {
  // //   id: '1891',
  // //   name: 'Pegasus Testnet',
  // //   nativeCurrency: { name: 'ETH', symbol: 'ETH', decimals: 18 },
  // //   rpcUrls: ['https://replicator.pegasus.lightlink.io/rpc/v1'],
  // //   tokenImg: 'https://i.ibb.co/7J0BZGf/lightlink-Logo.png',
  // //   explorerUrl: 'https://pegasus.lightlink.io/',
  // //   features: {
  // //     spinValue: 5,
  // //     mintValue: 10,
  // //     stakeValue: 100,
  // //     apiStaking: true,
  // //     gasLimit: true,
  // //   },
  // //   // contracts: {
  // //   //   NFT: new ethers.Contract(
  // //   //     "0xLightLinkNFTContractAddress",
  // //   //     stakeAbi // Replace with actual ABI for LightLink NFT
  // //   //   ),
  // //   //   Stake: new ethers.Contract(
  // //   //     "0xLightLinkStakeContractAddress",
  // //   //     stakeAbi // Replace with actual ABI for staking
  // //   //   ),
  // //   //   Token1: new ethers.Contract(
  // //   //     "0xLightLinkToken1Address",
  // //   //     tokenAbi // Replace with actual ABI for Token1
  // //   //   ),
  // //   //   Token2: new ethers.Contract(
  // //   //     "0xLightLinkToken2Address",
  // //   //     tokenAbi // Replace with actual ABI for Token2
  // //   //   ),
  // //   //   Game: new ethers.Contract(
  // //   //     "0xLightLinkGameContractAddress",
  // //   //     gameAbi // Replace with actual ABI for Game contract
  // //   //   ),
  // //   //   Product: new ethers.Contract(
  // //   //     "0xLightLinkProductContractAddress",
  // //   //     productAbi // Replace with actual ABI for Product contract
  // //   //   ),
  // //   // },
  // // },

  // // MORPH
  // // {
  // //   id: '2818',
  // //   name: 'Morph',
  // //   nativeCurrency: {
  // //     name: 'ETH',
  // //     symbol: 'ETH',
  // //     decimals: 18,
  // //   },
  // //   rpcUrls: ['https://rpc-quicknode.morphl2.io'],
  // //   blockExplorerUrls: ['https://explorer.morphl2.io/'],
  // //   tokenImg: 'https://i.ibb.co/Rv1Sc7T/morph-Logo.png',
  // //   features: {
  // //     gameValue: 0,
  // //     mintValue: 0.00041,
  // //     stakeValue: 0.00041,
  // //     unStakeValue: 0,
  // //     apiStaking: false,
  // //     apiMinting: false,
  // //   },
  // //   contracts: {
  // //     NFT: new ethers.Contract(
  // //       '0x67d91eC3d43FC21CbB3c6fFcc490677D077E8DfC',
  // //       stakeAbi
  // //     ),
  // //     Stake: new ethers.Contract(
  // //       '0x67d91eC3d43FC21CbB3c6fFcc490677D077E8DfC',
  // //       stakeAbi
  // //     ),
  // //     Token1: new ethers.Contract(
  // //       '0x60d94ae2a429be78a1099733356Ab88009B049EF',
  // //       tokenAbi
  // //     ),
  // //     Game: new ethers.Contract(
  // //       '0x4dE7CD522f1715b2a48F3ad6612924841d450A0F',
  // //       productGamesAbi
  // //     ),
  // //     Product: new ethers.Contract(
  // //       '0xa75A5bEE03CC551999C193159f68b68768e16d7D',
  // //       productAbi
  // //     ),
  // //   },
  // },
];
